import { useNavigate } from 'react-router'
import { ClipboardCheck } from 'lucide-react'
import { Card, Badge, Empty, PageHeader, Table, type Column } from '@concours/ui'
import { SHEET_VARIANT, useMySheets, type MySheet } from '../../lib/grading'
import { Progress } from './Progress'

/** Évaluateur : SES relevés uniquement (affectations faites par la commission). */
export function MySheetsPage() {
  const navigate = useNavigate()
  const sheets = useMySheets()
  const columns: Column<MySheet>[] = [
    {
      key: 'stage',
      header: 'Concours · étape',
      cell: (s) => (
        <span className="stack" style={{ gap: 2 }}>
          <strong>{s.stage}</strong>
          <span className="muted">{s.competition}</span>
        </span>
      ),
    },
    { key: 'discipline', header: 'Discipline', cell: (s) => s.discipline },
    { key: 'lot', header: 'Lot', cell: (s) => s.lot },
    { key: 'round', header: 'Correction', numeric: true, cell: (s) => s.round },
    {
      key: 'progress',
      header: 'Avancement',
      cell: (s) => <Progress {...s.progress} label={`Avancement ${s.lot}`} />,
    },
    {
      key: 'status',
      header: 'État',
      cell: (s) => <Badge variant={SHEET_VARIANT[s.status]}>{s.statusLabel}</Badge>,
    },
  ]
  return (
    <>
      <PageHeader
        eyebrow="Notes"
        title="Mes relevés de notes"
        description="Les lots qui vous ont été affectés. Saisissez au clavier, enregistrez, puis soumettez le relevé complet à la commission."
      />
      <Card>
        <Table
          columns={columns}
          rows={sheets.data ?? []}
          rowKey={(s) => s.id}
          loading={sheets.isPending}
          caption="Mes relevés"
          onRowClick={(s) => navigate(`/notes/releves/${s.id}`)}
          empty={
            <Empty
              icon={<ClipboardCheck aria-hidden="true" />}
              title="Aucun relevé affecté"
              description="La commission vous affectera des lots lorsque la notation sera ouverte."
            />
          }
        />
      </Card>
    </>
  )
}
